var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const defaultMiddlewares = [];
/**
 * !Important: Should be used for every getServerSideProps,
 * because 'gsspWrapper' contained some defaults middlewares
 *
 * How to use:
 * ...
 * export const getServerSideProps = gsspWrapper(...middlewares[], handler)
 * ...
 */
export const gsspWrapper = (...handlers) => {
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        for (const handler of [...defaultMiddlewares, ...handlers]) {
            const res = yield handler(ctx);
            if (res) {
                return res;
            }
        }
        return { props: {} };
    });
};
